export const AI_PERMISSION_CODES = {
  PROTOCOLS: 'INTELIGENCIA_ARTIFICIAL.PROTOCOLOS',
  VIEW_SECTION: 'INTELIGENCIA_ARTIFICIAL.VER_SECCION',
  CREATE_ANALYSIS: 'INTELIGENCIA_ARTIFICIAL.CREAR_ANALISIS',
  VIEW_ANALYSIS_DETAIL: 'INTELIGENCIA_ARTIFICIAL.VER_DETALLE_ANALISIS',
  GO_TO_CALL: 'INTELIGENCIA_ARTIFICIAL.IR_A_LLAMADA',
  NO_CLIENTES: 'INTELIGENCIA_ARTIFICIAL.NO_CLIENTES',
  NO_CLIENTES_VIEW_SECTION: 'INTELIGENCIA_ARTIFICIAL.NO_CLIENTES.VER_SECCION',
  NO_CLIENTES_VIEW_CALL: 'INTELIGENCIA_ARTIFICIAL.NO_CLIENTES.VER_LLAMADA',
  AUTOPSIA: 'INTELIGENCIA_ARTIFICIAL.AUTOPSIA',
  AUTOPSIA_VIEW_SECTION: 'INTELIGENCIA_ARTIFICIAL.AUTOPSIA.VER_SECCION',
};
